<template>
    
  <v-container>
    <v-row class="pa-0" style="position:relative">
      <video autoplay muted loop playsinline id="myVideo" style="width:100%;height:100%;background:black;">
        <source :src="require('../assets/homepage_video_medium_resolution.mp4')" type="video/mp4">
      </video>
      <div style="position:absolute;top:0;left:0;right:0;bottom:0;
  display: flex;
  justify-content: center;
  align-items: center;">
          <div>
            <div>
              <img class="banner-logo d-none d-sm-flex"
                contain
                :src="require('../assets/logo.png')"/>
            </div>
            <div :class="$i18n.locale=='en'?'georgia homepage-slogan-font-size':'NotoSerifTC homepage-slogan-font-size-chi'" class="banner-slogan bannertitle slogan-letterspacing" data-aos="showfromtopNobg" data-aos-delay="1000" data-aos-duration="50000" v-html="$t('homepage.slogan')">
            </div>
          </div>
      </div>
    </v-row>
    <v-row>
      <v-col v-if="!($vuetify.breakpoint.xs)" class="pa-0" lg="6" md="6"> 
        <div style="position:relative;color:white;padding-top: 105%;">
          <div style="position:absolute;top:0;left:0;background-color:black;width:100%;display: flex;height:100%;">
            <v-parallax
              style="position:absolute;top:0;left:0;height:100%;width:100%;"
              height=550
              :src="require('../assets/Chef.jpg')"
            />
          </div>
        </div>
      </v-col>
      <v-col class="pa-0" lg="6" md="6">
        <div class="about-us-block">
          <div class="d-flex flex-column justify-center about-us-block-child">
            <div style="position:relative;background-color:black;">
                <div 
                  :class="[$i18n.locale=='en'?'georgia font-size-l3':'NotoSerifTC font-size-l3-chi',  $vuetify.breakpoint.xs ?'text-center':'']" 
                  class="history-title"
                  >
                  {{ $t("homepage.about_us_title") }}
                </div>
                <div v-if="!$vuetify.breakpoint.xs" :class="[$i18n.locale=='en'?'din-condL font-size-l4 engletterspacing':'MHeiHK font-size-l4-chi chiletterspacing']"  class="history-paragraph" v-html="$t('homepage.about_us_content')">
                </div>
                <div v-if="$vuetify.breakpoint.xs" :class="[$i18n.locale=='en'?'din-condL font-size-l4 engletterspacing':'MHeiHK font-size-l4-chi chiletterspacing',  'text-center']"  class="history-paragraph" v-html="$t('homepage.about_us_content').replaceAll('<br>','')">
                </div>
                <div :class="[$i18n.locale=='en'?'din-condL font-size-l3':'MHeiHK font-size-l3-chi',  $vuetify.breakpoint.xs?'text-center':'']" class="history-paragraph">
                  <a class="d-inline-flex history-button" href="/company">{{ $t("homepage.read_more") }}</a>
                </div>
                <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row class="d-none d-md-flex"> -->
    <v-row class="d-flex">
      <v-col :class="$i18n.locale=='en'?'georgia homepage-slogan-font-size':'NotoSerifTC homepage-slogan-font-size-chi'" class="pa-0 slogan-letterspacing" style="background:#132b1b;color:white; position:relative;">
        <div :class="$i18n.locale=='en'?'georgia homepage-slogan-font-size':'NotoSerifTC homepage-slogan-font-size-chi'" class="slogan" v-html="$t('homepage.slogan2')">
        </div>
        <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
      </v-col>
    </v-row>
    <v-row >
      <v-col class="pa-0" lg="6" md="6">
        <div style="position:relative;color:white;padding-top: 76%;">
          <div style="position:absolute;top:0;left:0;background-color:black;width:100%;display: flex;height:100%;">
            <v-img
              height="100%"
              style="position:absolute;top:0;left:0;"
              :src="require('../assets/building.png')"
            />
          </div>
        </div>
      </v-col>
      <v-col class="pa-0" lg="6" md="6">
        <div style="position:relative;color:white;padding-top: 76%;">
          <div style="position:absolute;top:0;left:0;background-color:black;width:100%;display: flex;height:100%;">
            <v-parallax
              style="position:absolute;top:0;left:0;height:100%;width:100%;"
              :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm?100:500"
              :src="$vuetify.breakpoint.smAndDown?require('../assets/coffee_bean1.png'):require('../assets/coffee_bean.png')"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-0" lg="6" md="6">
        <div style="position:relative;color:white;padding-top: 76%;">
          <div style="position:absolute;top:0;left:0;background-color:black;width:100%;display: flex;height:100%;">
            <v-parallax
              style="position:absolute;top:0;left:0;height:100%;width:100%;"
              :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm?100:400"
              :src="$vuetify.breakpoint.smAndDown?require('../assets/black-truffle1.png'):require('../assets/black-truffle.jpg')"
            />
          </div>
        </div>
      </v-col>
      <v-col class="pa-0" lg="6" md="6">
        <div style="position:relative;color:white;padding-top: 76%;">
          <div style="position:absolute;top:0;left:0;background-color:black;width:100%;display: flex;height:100%;">
            <v-img
              height="100%"
              style="position:absolute;top:0;left:0;"
          :src="require('../assets/van.jpg')"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
     <v-col :class="$i18n.locale=='en'?'georgia homepage-slogan-font-size':'NotoSerifTC homepage-slogan-font-size-chi'" class="pa-0" style="background: white; letter-spacing:10px; position: relative;">
       <div class="slogan" v-html="$t('homepage.slogan3')">
       </div>
        <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
     </v-col>
    </v-row>
    <v-row class="hpslider" id="hpslider">
       <VueSlickCarousel v-bind="$vuetify.breakpoint.xs?VSCMobile:VSCDesktop" style="position:absolute;top:0;height: 100%;left:0;right:0;overflow:hidden;">
          <div>
            <img
              :src="require('../assets/homepage_slider/A002_R_home slider.jpg')"
            />
          </div>
          <div>
            <img
              :src="require('../assets/homepage_slider/B001_R_home slider.jpg')"
            />
          </div>
          <div>
            <img
              :src="require('../assets/homepage_slider/C003_R_home slider.jpg')"
            />
          </div>
          <div>
            <img
              :src="require('../assets/homepage_slider/D001_R_home slider.jpg')"
            />
          </div>
         <div>
            <img
              :src="require('../assets/homepage_slider/E001_R_home slider.jpg')"
            />
          </div>
         <div>
            <img
              :src="require('../assets/homepage_slider/F003_R_home slider.jpg')"
            />
          </div>
         <div>
            <img
              :src="require('../assets/homepage_slider/G001_R_home slider.jpg')"
            />
          </div>
          <div>
            <img
              :src="require('../assets/homepage_slider/H003_R_home slider.jpg')"
            />
          </div>
          <div>
            <img
              :src="require('../assets/homepage_slider/I004_R_home slider.jpg')"
            />
          </div>
          <div>
            <img
              :src="require('../assets/homepage_slider/Jbus01_R_home slider.jpg')"
            />
          </div>
         <div>
            <img
              :src="require('../assets/homepage_slider/Kbus02_R_home slider.jpg')"
            />
          </div>
          <div>
            <img
              :src="require('../assets/homepage_slider/Lbus03_R_home slider.jpg')"
            />
          </div>


          <!-- <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/A002_R_home slider.jpg')"
            />
          </div>
          <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/B001_R_home slider.jpg')"
            />
          </div>
          <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/C003_R_home slider.jpg')"
            />
          </div>
          <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/D001_R_home slider.jpg')"
            />
          </div>
         <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/E001_R_home slider.jpg')"
            />
          </div>
         <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/F003_R_home slider.jpg')"
            />
          </div>
         <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/G001_R_home slider.jpg')"
            />
          </div>
          <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/H003_R_home slider.jpg')"
            />
          </div>
          <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/I004_R_home slider.jpg')"
            />
          </div>
          <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/Jbus01_R_home slider.jpg')"
            />
          </div>
         <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/Kbus02_R_home slider.jpg')"
            />
          </div>
          <div>
            <v-img
              height="100%"
              :src="require('../assets/homepage_slider/Lbus03_R_home slider.jpg')"
            />
          </div> -->
        </VueSlickCarousel>
    </v-row>
  </v-container>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  // function getWidth() {
  // return Math.max(
  //     document.body.scrollWidth,
  //     document.documentElement.scrollWidth,
  //     document.body.offsetWidth,
  //     document.documentElement.offsetWidth,
  //     document.documentElement.clientWidth
  //   );
  // }
  // alert('Width:  ' +  getWidth() );

  export default {
    name: 'Homepage',
    components: {
      VueSlickCarousel
    },
    data: () => ({
      "VSCDesktop": {
        "arrows": false,
        "dots": false,
        "infinite": true,
        "slidesToShow": 2.2,
        "slidesToScroll": 1,
        "autoplay": true,
        "autoplaySpeed": 4000,
        "centerMode": true,
        // "arrows": false,
        // "dots": false,
        // "infinite": true,
        // "slidesToShow": 2.2,
        // "slidesToScroll": 1,
        // // "edgeFriction": 1,
        // "centerMode": true,
        // // "centerPadding": "5%",
        // // lazyLoad: "progressive",
        // "autoplay": true,
        // "autoplaySpeed": 24000,
        // "speed": 12000,//8000
        // "pauseOnDotsHover": true,
        // "pauseOnFocus": true,
        // "pauseOnHover": true,
        // "cssEase": "linear",
        // // "useTransform": false
      },
       "VSCMobile": {
        "arrows": false,
        "dots": false,
        "infinite": true,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "autoplay": true,
        "autoplaySpeed": 4000,
        "centerMode": true,
        // "arrows": false,
        // "dots": false,
        // "infinite": true,
        // "slidesToShow": 1.2,
        // "slidesToScroll": 1,
        // // "centerMode": true,
        // // "centerPadding": "5%",
        // "autoplay": true,
        // "autoplaySpeed": 0,
        // "speed": 8000,
        // "pauseOnDotsHover": true,
        // "pauseOnFocus": true,
        // "pauseOnHover": true,
        // "cssEase": "linear"
      },
      methods: {
        goto: function(routerName, params, hash=null){
          if(hash){
            this.$router.replace({ name: routerName, params: params, hash: hash});
          }else{
            this.$router.replace({ name: routerName, params: params});
          }
          if(routerName==this.$router.history.current.name){
            location.reload();
          }
        }
      }
    }),
  }
</script>

<style scoped>
.videobg-container{
  padding: 0;
  position: relative;
}
.videobg{
  position: absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
}
.banner-logo{
  max-width: 20%;
  margin: auto;
}
.banner-slogan{
  text-align: center;
  margin: auto;
  color: white;
}
.history-session{
  position: relative;
  padding-top: 52%;
}
.about-us-block{
  position:relative;
  background-color:black; 
  color:white;
  padding-top: 105%;
}
.mobile .about-us-block{
  position:relative;
  background-color:black; 
  color:white;
  padding: 20px;
}
.about-us-block-child{
  position:absolute;
  top: 0;
  left:0;
  height:100%;
  width:100%;
}
.mobile .about-us-block-child{
  position:relative;
  padding: 20px;
  top: auto;
  left: auto;
}
.history-title{
  width: 70%;
  text-align: left;
  color: white;
  margin: auto;
  letter-spacing:10px;
}
.mobile .history-title{
  width: 84%;
  color: white;
  margin: auto;
  letter-spacing:5px;
  font-size: 20px;
}
.history-paragraph{
  width: 70%;
  text-align: left;
  color: white;
  margin: auto;
  margin-top:30px; 
}

.engletterspacing{
  letter-spacing: 2px;
}

.chiletterspacing{
  letter-spacing: 5px;
}

.mobile .history-paragraph{
  width: 80%;
  text-align: center;
  color: white;
  margin: auto;
  margin-top:16px; 
  letter-spacing:1px;
  line-height: 1.2;
}
.history-button{
  color: black;
  background-color: white !important;
  cursor: pointer;
}
.history-button:hover{
  color: white;
  background-color: #1d953b !important;
}
.din-cond{
  font-family:'DinCond', Helvetica, Arial;
}

.din-condL{
  font-family: 'DinCondL';
}

.homepage-block-image{
  width:100%; 
  padding-top:70%;
  position:relative;
}

.bannertitle{ 
  margin-top:50px;
}

.georgia{
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.slogan{
  margin-top: 80px;
  margin-bottom: 80px;
}

.mobile .slogan{
  margin-top: 20px;
  margin-bottom: 20px;
  letter-spacing: 2px !important;
}


.mobile .history-button{
  margin-top: 10px;
  padding: 10px 38px;
}

.hpslider{
  margin-top: 20px;
  padding-top: 32%;
  position: relative;
}

.mobile .hpslider{
  z-index: 50;
  margin-top: 10px;
  padding-top: 55%;
  position: relative;
}

@media (min-width: 576px) {
  .history-button{
    margin-top:30px; 
    font-weight:1000; 
    border-radius:0; 
    padding:30px; 
    font-size:25px;
  }
}

@media (min-width: 768px) {
  .history-button{
    margin-top:23px; 
    font-weight:100; 
    border-radius:0; 
    padding:40px; 
    padding-top:9px;
    padding-bottom:9px;
    font-size:18px;
    letter-spacing: 1px;
  }
}

@media (min-width: 992px) { 
  .history-button{
    margin-top:23px; 
    font-weight:100; 
    border-radius:0; 
    padding:40px; 
    padding-top:9px;
    padding-bottom:9px;
    font-size:18px;
    letter-spacing: 1px;
  }
}

@media (min-width: 1264px) {
  .history-button{
    margin-top:30px; 
    font-weight:100; 
    border-radius:0; 
    padding:42px; 
    padding-top:10px;
    padding-bottom:10px;
    font-size:20px;
    letter-spacing: 1px;
  }
}

@media (min-width: 1904px){
  .history-button{
    margin-top:30px; 
    font-weight:100; 
    border-radius:0; 
    padding:42px; 
    padding-top:10px;
    padding-bottom:10px;
    font-size:20px;
    letter-spacing: 1px;
  }
}
@media (min-width: 375px){
  .slogan-letterspacing{
    letter-spacing: 3px;
  }
}


@media (min-width: 768px){
  .slogan-letterspacing{
    letter-spacing: 5px;
  }
}

@media (min-width: 992px){
  .slogan-letterspacing{
    letter-spacing: 5px;
  }
}

@media (min-width: 1264px){
  .slogan-letterspacing{
    letter-spacing: 10px;
  }
}

@media (min-width: 1904px){
  .slogan-letterspacing{
    letter-spacing: 10px;
  }
}
</style>

<style>
/* the parent */
.slick-list {
    margin: 0 -10px;
}

.mobile .slick-list {
    margin: 0 !important;
}

</style>